import { useTranslation } from 'react-i18next'
import { Button, Flex, Icon, Typography } from '@percent/lemonade'
import styles from './GrantAdvisoryBookingModal.module.scss'

type SorryScreenProps = {
  onClose: () => void
}

export const SorryScreen = ({ onClose }: SorryScreenProps) => {
  const { t } = useTranslation()

  return (
    <div className={`${styles.questionnaireFrame} ${styles.stepEnter}`}>
      <Flex direction="column" align="center" gap={16} data-testid="grant-questionnaire-sorry">
        <Icon name="info" size={8} color="gray400" />
        <Typography variant="h4" className={styles.centeredText}>
          {t('grantAdvisoryQuestionnaire.sorry.title')}
        </Typography>
        <Typography variant="small" $color="gray500" className={styles.centeredText}>
          {t('grantAdvisoryQuestionnaire.sorry.description')}
        </Typography>
        <Button variant="primary" stretch onClick={onClose} data-testid="grant-questionnaire-sorry-close">
          {t('grantAdvisoryQuestionnaire.sorry.close')}
        </Button>
      </Flex>
    </div>
  )
}
